<template>
  <div class="">

    <portlet
        :icon="'fal fa-chart-pie portlet-icon'"
        :title="$t('menu.oeeAnalytics')"
        :actions-block="false"
        :fullheight="true"
        class="portlet-pt-20 oee-chart-portlet"
    >
      <template slot="portletBody">
        <div class="row gauges">
          <div class="gauges-col col-12">
            <OEEGauges :performance="performance" :availablity="availablity" :quality="quality"/>
          </div>
        </div>

        <div class="row bar-charts">
          <div class="col-sm-12 col-md-4">
            <OEEEBarChartsGroupped :performance="performance"
                                   :availablity="availablity" :quality="quality"/>
          </div>
          <div class="col-sm-12 col-md-8">
            <OEEEBarChartsStacked @chartClicked="chartClicked($event)"
                                  :performance="performance" :availablity="availablity" :quality="quality"/>
          </div>
        </div>

      </template>
    </portlet>


  </div>
</template>

<script>
import {mapGetters} from "vuex";
import OEEGauges from "@/components/oeeAnalytics/components/OEE/OEEGauges";
import OEEEBarChartsStacked from "@/components/oeeAnalytics/components/OEE/OEEEBarChartsStacked";
import OEEEBarChartsGroupped from "@/components/oeeAnalytics/components/OEE/OEEEBarChartsGroupped";
import oeeCalculations from "@/mixins/oeeAnalytics/oeeCalculations";

export default {
  name: "OeeCharts",
  mixins: [oeeCalculations],
  props:['updateDataTrigger'],
  components: {
    OEEEBarChartsStacked,
    OEEGauges,
    OEEEBarChartsGroupped
  },
  data() {
    return {
      availablity: null,
      performance: null,
      quality:null
    }
  },
  computed: {
    ...mapGetters('company', ['getBdrTimeFrame', 'getProductNumberKey', 'getNpcKey']),
    ...mapGetters('oeeAnalytics', ['getWorkflowId', 'getSelectedDate', 'getUnit', 'getDateRange']),


  },
  methods: {
    updateData() {
      this.availablity = null;
      this.performance = null;
      // this.$store.commit('oeeAnalytics/setSelectedDate',null)
      this.getAvailability();
      this.getPerformance();
      this.getQuality();
    },
    chartClicked(event) {
      this.$store.commit('oeeAnalytics/setSelectedDate', moment(event.date, 'DD-MM-YYYY').toDate());
    },
    async getAvailability() {
      let query = {
        fromDate:this.getDateRange.fromDate.toISOString(),
        toDate: this.getDateRange.toDate.toISOString(),
        unit: this.getUnit,
        workflowId: this.getWorkflowId,
        useShiftsPerWorkflowTable: true
      }
      let availablity = await this.$FUNCTIONS.OeeAnalytics("getAvailability", query).catch(e => {
        console.error(e);
      })
      this.availablity = availablity.data
    },
    async getPerformance() {
      let query = {
        fromDate: this.getDateRange.fromDate.toISOString(),
        toDate: this.getDateRange.toDate.toISOString(),
        workflowId: this.getWorkflowId,
        unit: this.getUnit,
        productNumberKey: this.getProductNumberKey,
        npcKey: this.getNpcKey
      }
      let performance = await this.$FUNCTIONS.OeeAnalytics("getPerformance", query).catch(e => {
        console.error(e);
      })
      this.performance = performance.data;
    },
    async getQuality(){
      let query = {
        fromDate: this.getDateRange.fromDate.toISOString(),
        toDate: this.getDateRange.toDate.toISOString(),
        workflowId: this.getWorkflowId,
        unit: this.getUnit
      }
      let quality = await this.$FUNCTIONS.OeeAnalytics("getQuality", query).catch(e => {
        console.error(e);
      })
      this.quality = quality.data;
     },
  },
  watch: {
    updateDataTrigger: {
      deep: true,
      handler() {
        this.updateData();
      }
    },
    'getDateRange':
        {
          deep: true,
          handler(newValue, oldValue) {
            // this.updateData();
          }
        },
    'getWorkflowId':
        {
          deep: false,
          handler() {
            // this.updateData();
          }
        }
  },
  created() {
    if (this.getDateRange.toDate && this.getDateRange.fromDate) {
      // this.updateData();
    }
  }
}
</script>

<style scoped>
.oee-controls {
  width: 300px;
}

/* Override the height of the porlet head (only if its part of the oee-chart-portlet so it doesnt change anywhere else) */
.oee-chart-portlet > .m-portlet__head {
  height: 10rem !important;
}

.bar-charts {
  margin-top: 4rem;
}

.gauges, .bar-charts {
  min-height: fit-content;
}

.gauges-col {
  text-align: center;
}

</style>